// Workflow Status Configurable on UI
export const STATUS_MAP = {
  "Not_Started": "Not Started",
  "First_Review": "First Review",
  "QA_Review": "Speaker Verified",
  "Compliance": "First Draft Final",
  "Publication": "Human Perfect",
}
const STATUS_COLORS = {
  "Not_Started": '#9297A0',
  "First_Review": '#C13E7B',
  "QA_Review": '#6B65BD',
  "Compliance": '#1F75C1',
  "Publication": '#20B662',
};
export const PRIORITY_MAP = {
  1: 'Critical',
  2: 'Very High',
  3: 'High',
  4: 'Moderate',
  5: 'Low',
  6: 'Lowest'
};

export const PARTNER_IDS = [
  "9bf61454-565b-4b39-b085-f420a116c97e", // Quartr
  "2a9fe8a6-9ace-49fb-b04c-8a936acfe6fd", // Aiera
  "f5c3c46f-f6a6-4436-b35b-f160d80f4a16", // Tegus
  "d71f9036-ec71-4819-ac1e-807b67d53540", // Third Bridge
]

export const PARTNER_CODE_NAMES = {
  "9bf61454-565b-4b39-b085-f420a116c97e": "MANTIS", // Quartr
  "2a9fe8a6-9ace-49fb-b04c-8a936acfe6fd": "CRICKET", // Aiera
  "f5c3c46f-f6a6-4436-b35b-f160d80f4a16": "BEETLE", // Tegus
  "d71f9036-ec71-4819-ac1e-807b67d53540": "SPIDER", // Third Bridge
};

export const PRIORITY_MAP_SELECT = Object.entries(PRIORITY_MAP).map(([value, label]) => ({ value: Number(value), label }));
// UHP (Ultra High Priority) title patterns
export const UHP_TITLE_PATTERNS = ["insight-venture-", "aiec", "concierge"];

/**
 * Check if a title matches UHP (Ultra High Priority) patterns
 * @param {string} title - The workflow title to check
 * @returns {boolean} True if title matches any UHP pattern
 */
export const isUhpTitle = (title) => {
  if (!title) return false;
  const lowerTitle = title.toLowerCase();
  return UHP_TITLE_PATTERNS.some(pattern => lowerTitle.includes(pattern));
};

// Legacy export for backwards compatibility
export const ULTRA_HIGH_PRIORITY_TEXT = "insight-venture-";
export const STATUS_MAP_SELECT = Object.entries(STATUS_MAP).map(([value, label]) => ({ value, label }));
export const STATUS_OPTIONS = STATUS_MAP_SELECT.map(option => ({
  ...option,
  color: STATUS_COLORS[option.value]
}));
export const getFormattedDuration = (timeInSeconds) => {
  try {
    const hours = String(Math.floor(timeInSeconds / (60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((timeInSeconds % (60 * 60)) / 60)).padStart(2, '0');
    const seconds = String(Math.floor(timeInSeconds % 60)).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  } catch (e) {
    // noop
  }
};

// Some endpoints return `assignees` as ["uid", ...] (strings); the editor's
// /enterprise/workflow/<id> response replaces each with the full user-detail
// dict via get_assignee_details(...). Accept both shapes.
const _assigneeUid = (entry) =>
  typeof entry === "string" ? entry : entry?.user_id;

// Match assignees by partner company_name base (env-agnostic: "tegus", "tegus-staging", ...).
// The editor's assignee objects carry the full user doc; bare-uid-string assignees won't match.
const _companyNameMatches = (assignees, bases) => {
  if (!Array.isArray(assignees)) return false;
  return assignees.some((a) => {
    if (typeof a !== "object" || !a) return false;
    const name = (a.company_name || "").toLowerCase().trim();
    return bases.some((b) => name === b || name.startsWith(b + "-"));
  });
};

export const isTegusFile = (assignees) => _companyNameMatches(assignees, ["tegus"]);

// Expert-network partners whose calls skip AI speaker verification.
const _EXPERT_NETWORK_BASES = ["tegus", "thirdbridge", "prosapient"];
export const isExpertNetworkCall = (assignees) =>
  _companyNameMatches(assignees, _EXPERT_NETWORK_BASES);

export const getPartnerCodeName = (assignees) => {
  if (!Array.isArray(assignees)) return "";
  for (const entry of assignees) {
    const uid = _assigneeUid(entry);
    if (uid && PARTNER_CODE_NAMES[uid]) return PARTNER_CODE_NAMES[uid];
  }
  return "";
};

// Every partner renders as its code name, for every role. The tag predated
// PARTNER_CODE_NAMES and kept one partner's real name for admins; no client's
// real name belongs in the UI.
export const getFileTag = (assignees) => {
  const partnerCodeName = getPartnerCodeName(assignees);

  return partnerCodeName ? `[${partnerCodeName}] ` : "";
};
